const elementary = (target = document) => {

	const obs = new ResizeObserver(entries => {

		for (const e of entries) {

			const el      = e.target // Get target element
			const sizes   = el.getAttribute('data-elementary').split(',') // Get sizes as array
			const elWidth = el.clientWidth // Get element current width

			const exceededWidths = []

			// Loop through sizes and add those that have been exceeded to array
			for (const s of sizes) {
				if ((parseInt(s) <= elWidth)) {
					exceededWidths.push(s)
				}
			}

			// Set array contents as comma-separated string on data attribute on element
			el.setAttribute('data-minwidth', exceededWidths.join(' '))
		}
	})

	for (const el of target.querySelectorAll('[data-elementary]')) {

		obs.observe(el)
	}
}

export default function() {
    elementary();
}
